
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const stockOpeningService = {
    stockOpeningList,
    stockOpeningDetails,
    submitStockOpening



};




//========= STOCK Opening
async function  stockOpeningList() {
    return apiClient.get(`/stock/stock-opening-list`, authHeader());
}

async function  stockOpeningDetails(stockId) {
    return apiClient.get(`/stock/stock-opening-details/${stockId}`, authHeader());
}


async function  submitStockOpening(formData) {
    return apiClient.post(`/stock/submit-stock-opening`,formData, authHeader());
}



// async function  stockAdjustmentListByDate(body) {
//     return apiClient.put(`/stock/stock-adjustment-by-date`, body, authHeader());
// }


// async function  stockAdjustmentSearch(searchText) {
//     return apiClient.get(`/stock/stock-adjustment-search?search=${searchText}`, authHeader());
// }






async function  stockAdjustmentAction(formData) {
    return apiClient.put(`/stock/stock-adjustment-action`,formData, authHeader());
}





// ============= STOCK Opening END============



















